import API from './base';

const version = 'v1';
const transfer = '/transfer';

export default {
  getZones(payload) {
    return API.get(`${version}${transfer}/zones/${payload}`);
  },
  getCityInfo(payload) {
    return API.get(`${version}${transfer}/info/${payload}`);
  },
  getVehicles(payload) {
    return API.get(`${version}${transfer}/vehicles`, {
      params: payload,
    });
  },
  getVehiclesByStoreId(payload) {
    return API.get(`${version}${transfer}/vehicles-by-store`, {
      params: payload,
    });
  },
  addToCart(payload) {
    return API.post(`${version}${transfer}/add-to-cart`, payload);
  },

  checkout(id, payload) {
    return API.post(`${version}${transfer}/checkout/${id}`, payload);
  },
  payment(id, payload) {
    return API.post(`${version}${transfer}/payment/${id}`, payload);
  },
  getTransferBookings() {
    return API.get(`${version}${transfer}`);
  },
};
